// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"47aaf9d7","313":"0811d62e","453":"96453769","656":"464540d0","802":"44b0a59c","877":"ca32c63b"}[chunkId] + ".chunk.js";
};